export default "__VITE_ASSET__f2dda840__"